import { redirect } from "react-router-dom";
import { logoutUser } from "../authApi";

export async function action() {
  await logoutUser();
  return redirect("/");
}
